export type NearbyNpc={id:string;x:number;range:number};

export function nearestNpc<T extends NearbyNpc>(npcs:readonly T[],x:number):T|undefined {
 if(!Number.isFinite(x))return;
 return npcs.filter(npc=>Math.abs(npc.x-x)<=npc.range).sort((a,b)=>Math.abs(a.x-x)-Math.abs(b.x-x))[0];
}
